module.exports = __webpack_public_path__ + "img/rankLogo.56083526.jpg";